(() => {
  const initRelatedProductsSlider = () => {
    const sliderElement = document.querySelector('.js-related-products-slider');
    
    if (sliderElement) {
      new Swiper(sliderElement, {
        slidesPerView: 1.6,
        spaceBetween: 16,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            navigation: {
              nextEl: sliderElement.querySelector('.swiper-button-next'),
              prevEl: sliderElement.querySelector('.swiper-button-prev'),
            },
          },
        },
      });
    }
  };

  const recommendationsElement = document.querySelector('product-recommendations');

  if (recommendationsElement) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          initRelatedProductsSlider();
          observer.disconnect();
          break;
        }
      }
    });

    observer.observe(recommendationsElement, { childList: true, subtree: true });
  }
})();
